import React from 'react';
import logo from '../../../../../assets/images/Full_Logo_Black.svg';
import logodark from '../../../../../assets/images/Full_Logo_White.svg';

export default function PoweredBy() {
  return (
    <div className="w-100 d-flex justify-content-center align-items-center my-3">
      <label className="p-2 me-1">
        <b>Powered by</b>
      </label>
      <img src={document.documentElement.getAttribute('data-theme') === 'dark' ? logodark : logo} alt="logo" width="88" />
    </div>
  );
}
